import axios from "axios";

const params ={
    headers: {
        Authorization: "bearer " + process.env.REACT_APP_STRAPI_APP_API,
    },
};

export const fetchDataFromApi = async (url) => {
    try {
        const {data} = await axios?.get(process.env.REACT_APP_DEV_URL + url, params);
        console.log(data);
        console.log(process.env.REACT_APP_DEV_URL + url);
        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
}